@for (tag of (tags() ?? []); track tag) {
  <span class="tag me-1">
    #{{ tag?.tr?.name }}
    @if (canModify()) {
      <a (click)="showRemoveTag(tag)" class="mx-1">
        <lucide-icon [img]="icons.delete" size="16"></lucide-icon>
      </a>
    }
  </span>
}
@if (canModify()) {
  <button type="button" class="btn btn-link btn-sm" (click)="showAddTag()">
    Add a tag
  </button>
}

<dialog class="p-4" #addTagDialog>
  <p class="fw-bold">
    Add a new tag
  </p>
  <form [formGroup]="addTagForm" (ngSubmit)="addTag()">
    <app-activity-tag-field
      [label]="'Tag'"
      [formControl]="addTagForm.controls.tag">
    </app-activity-tag-field>
    <p class="text-end">
      <button type="button" class="btn btn-link mx-1" (click)="closeAddTag()">Cancel</button>
      <button type="submit" class="btn btn-primary" [disabled]="addTagForm.invalid">
        <lucide-icon [img]="icons.plus"></lucide-icon>
        Add tag
      </button>
    </p>
  </form>
</dialog>

<dialog class="p-4" #removeTagDialog>
  <p class="text-danger">
    Remove tag {{ tagToRemove()?.tr?.name }}?
  </p>
  <p class="text-end">
    <button type="button" class="btn btn-link mx-1" (click)="closeRemoveTag()">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="removeTag()">
      <lucide-icon [img]="icons.delete"></lucide-icon>
      Remove tag
    </button>
  </p>
</dialog>
